<template>
  <div class="free-ad">
    <div class="title">
      购买单会员后 3 个月可补差价优惠升级联合会员，3 个月后请单独购买其他单会员
    </div>
    <div class="content-bg">
      <div class="content">
        <div class="logo">LOGO</div>
        <div class="logo">LOGO</div>
        <div class="logo">LOGO</div>
        <div class="logo">LOGO</div>
        <div>
          <div class="one">{{ APP_NAME }}<span class="dot"></span>联合会员</div>
          <div class="two">一个账号可同时用于三大领域教育平台</div>
        </div>
        <div class="price">¥398/年</div>
        <div class="btntxt" @click="buy">点击购买</div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { APP_NAME } from '@/utils/const'
const buy = () => {
  console.log('点击购买')
}
</script>
<style scoped>
.free-ad {
  padding: 30px 0;
  width: 100vw;
  box-sizing: border-box;
}
.title {
  font-size: 14px;
  color: #333;
  text-align: center;
  margin-bottom: 10px;
}
.content-bg {
  background-color: #303030;
  width: 100%;
  display: flex;
  justify-content: center;
}
.content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  padding: 10px 0;
  box-sizing: border-box;
  width: 1080px;
}
.price {
  font-size: 24px;
  color: #fff;
  font-weight: 700;
}
.btntxt {
  border: 1px solid #fff;
  border-radius: 4px;
  padding: 5px 10px;
  cursor: pointer;
}
.one {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-size: 28px;
  font-weight: 600;
}
.dot {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #fff;
}
.two {
  font-size: 12px;
}
</style>